import {
    AUTHENTICATING_ZOHO_REQUEST, AUTHENTICATING_ZOHO_SUCCEDDED, AUTHENTICATING_ZOHO_FAILED,
    UPDATING_ZOHO_REQUEST, UPDATING_ZOHO_SUCCEDDED, UPDATING_ZOHO_FAILED,
  } from '../../actions/actionTypes.jsx';
  
  const initialState = {
  changes: {
    saving: false,
    error: null
  },
  authentication: {
    authenticating: false,
    error: null
  }
  };
  
  function zohoReducer(state = initialState, action) {
  switch (action.type) {
    case AUTHENTICATING_ZOHO_REQUEST:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: true,
          error: null
        }
      })
    case AUTHENTICATING_ZOHO_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: false,
          error: null
        }
      })
    case AUTHENTICATING_ZOHO_FAILED:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: false,
          error: action.payload
        }
      }) 
    case UPDATING_ZOHO_REQUEST:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: true,
          error: null
        }
      })
    case UPDATING_ZOHO_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: null
        }
      })
    case UPDATING_ZOHO_FAILED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: action.payload
        }
      })
    default:
      return state;
  }
  }
  
  export { zohoReducer };